import { CalendarView } from '../hooks/useCalendarNav';

// The Today / Week / Day segmented control (GRAVY-10329).
//
// Figma `Admin-Dashboard x 1024` (39124:32612): a 2px-inset bordered track on
// #fcfcfc with 8px radius, 32px items with 16px padding, and the active item
// filled green at radius 6.
//
// **Today is a jump, not a view.** The frame styles it with the deactivated
// text colour while Day is filled green, and there is no third thing to be
// looking at: "today" is a date, and Week/Day are the two spans. So it moves the
// anchor to today and disables itself once you are there, while Week and Day are
// the mutually exclusive modes carrying `aria-pressed`.

type Props = {
  view: CalendarView;
  onViewChange: (next: CalendarView) => void;
  onToday: () => void;
  /** True when the anchor already covers today, so Today would do nothing. */
  isOnToday: boolean;
  /** Phone: Today alone. The calendar is pinned to Day there (GRAVY-10991),
   *  so a Week/Day choice would be one that cannot be made. */
  todayOnly?: boolean;
};

const CalendarViewToggle = ({
  view,
  onViewChange,
  onToday,
  isOnToday,
  todayOnly = false,
}: Props) => (
  <div className="dashv2-viewtoggle" data-testid="calendarViewToggle">
    <button
      type="button"
      className="dashv2-viewtoggle-btn"
      data-testid="viewToggle-today"
      onClick={onToday}
      disabled={isOnToday}
    >
      Today
    </button>
    {(todayOnly ? [] : (['week', 'day'] as const)).map((mode) => (
      <button
        key={mode}
        type="button"
        className={`dashv2-viewtoggle-btn${view === mode ? ' is-active' : ''}`}
        data-testid={`viewToggle-${mode}`}
        // The pressed state IS the view state, so a screen reader hears what
        // the green fill shows.
        aria-pressed={view === mode}
        onClick={() => onViewChange(mode)}
      >
        {mode === 'week' ? 'Week' : 'Day'}
      </button>
    ))}
  </div>
);

export default CalendarViewToggle;
